import {Component, OnInit, ViewChild} from '@angular/core';
import {NavParams, ViewController} from "ionic-angular";
import {AngularCropperjsComponent} from "angular-cropperjs";

/**
 * Generated class for the ImageEditComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'image-edit',
  templateUrl: 'image-edit.html'
})
export class ImageEdit implements OnInit{
  @ViewChild('angularCropper') public angularCropper: AngularCropperjsComponent;

  image: string;
  isAttachementFile: boolean = false;
  cropperOptions: any;

  scaleValX = 1;
  scaleValY = 1;

  constructor(private viewCtrl: ViewController,
              private navParams: NavParams) {
    this.cropperOptions = {
      dragMode: 'crop',
      aspectRatio: 1,
      autoCrop: true,
      movable: true,
      zoomable: true,
      scalable: true,
      autoCropArea: 1,
      viewMode: 2
    };
  }

  ngOnInit() {

    let file = this.navParams.get('file');

    this.isAttachementFile = file.type.indexOf('image') === -1;

    if (file) {
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
    }
  }

  close(image?) {
    this.viewCtrl.dismiss({image: image});
  }


  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    console.log(binaryString)
    if(!this.isAttachementFile){
      this.image = "data:image/png;base64," + btoa(binaryString);
    }else{
      this.image = binaryString;
    }
  }

  reset() {
    this.angularCropper.cropper.reset();
  }

  clear() {
    this.angularCropper.cropper.clear();
  }

  rotate() {
    this.angularCropper.cropper.rotate(90);
  }

  zoom(zoomIn: boolean) {
    let factor = zoomIn ? 0.1 : -0.1;
    this.angularCropper.cropper.zoom(factor);
  }

  scaleX() {
    this.scaleValX = this.scaleValX * -1;
    this.angularCropper.cropper.scaleX(this.scaleValX);
  }

  scaleY() {
    this.scaleValY = this.scaleValY * -1;
    this.angularCropper.cropper.scaleY(this.scaleValY);
  }

  move(x, y) {
    this.angularCropper.cropper.move(x, y);
  }

  toggleResize() {
    // this.cropperOptions.zoomable = !this.cropperOptions.zoomable;
    // this.cropperOptions.scalable = !this.cropperOptions.scalable;
    //
    // this.angularCropper.cropperOptions = this.cropperOptions;
  }


  async cropSave() {
    let cropperData = await this.angularCropper.cropper.getData(true)
    let croppedImgB64String: string = this.angularCropper.cropper.getCroppedCanvas().toDataURL('image/jpeg', (100 / 100));
    if(cropperData.width > 400 || cropperData.height > 400){
      await this.compressImage(croppedImgB64String, 400, 400).then((res) => this.image = res as string);
    }else{
      this.image = croppedImgB64String;
    }

    this.close(this.image);
  }

  // Compression
  compressImage(src, newX, newY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        elem.width = newX;
        elem.height = newY;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, newX, newY);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/new-post/image-edit/image-edit.ts